enum AddressView {
    Search = "search",
    ReadOnly = "readonly",
    Edit = "edit",
}

export { AddressView };